export default __webpack_public_path__ + "static/media/intern_fear_1.400e0197.png";